import React from 'react';
import PropTypes from 'prop-types';

const LegendDescription = ({description}) => (
  <div className="LegendDescription">
    <p className="LegendDescription__title">{description}</p>
  </div>
);

LegendDescription.propTypes = {
  description: PropTypes.string.isRequired,
};

export default LegendDescription;



// WEBPACK FOOTER //
// ./src/components/LegendDescription.js